import { AppointmentType } from '@dialogue/timekeeper'

import { useProviderSelection } from '../ProviderBased/useProviderSelection'
import { BOOKING_FLOW } from '../constants'

/**
 * Returns the booking flow ("provider-based" vs "time-based") for a given appointment type.
 */
export const useBookingFlow = (appointmentType: AppointmentType): BOOKING_FLOW => {
  const { showProviderSelection } = useProviderSelection(appointmentType)

  return showProviderSelection ? BOOKING_FLOW.PROVIDER_BASED : BOOKING_FLOW.TIME_BASED
}
